import { makeObservable, observable, runInAction, reaction, toJS } from 'mobx';
import axios from "../utils/axios";
import {storeGet} from "../utils/functions";
import reactionCombiner from "../utils/reactionCombiner";

class exportStore {
  data={};
  options={};
  export_options={
    use_filter: 1,
    use_order: 1
  };
  export_fields=[];
  category_fields={fetching:false, inited: false, data:{}};
  submit_result=null;
  submitting=false;
  comb=null;
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
      export_fields: observable,
      category_fields: observable,
      export_options: observable,
    });

    this.options.inputName=dataset.inputName

    this.comb=new reactionCombiner();

    if(dataset.data) {
      const json=JSON.parse(dataset.data);
      if(json) {
        this.data=json;
      }
    }

    this.comb.addReaction(()=>{
      return this.category_fields.inited;
    },(inited)=>{
      if(inited) {
        runInAction(()=>{
          this.category_fields.data.forEach((item)=>{
            this.export_fields.push({
              code: item.code,
              name: item.name,
              export: this.isExport(item),
              options: {},
            });
          });
        });
      }
    });

    if(this.data.category) {
      this.fetchCategoryFields();
    }

  }
  isExport(item) {
    if(!this.data.selected || !this.data.selected.length) {
      return true;
    }
    const filterByCode=this.data.selected.filter((selItem)=>{
      return selItem.code == item.code.replace(":","_");
    });
    if(filterByCode.length) {
      return true;
    }
    return false;
  }
  unselectAll() {
    runInAction(() => {
      this.export_fields.forEach((item) => {
        item.export = false;
      })
    });
  }
  selectAll() {
    runInAction(()=>{
      this.export_fields.forEach((item)=>{
        item.export=true;
      })
    });
  }
  isAllSelected() {
    const flt=this.export_fields.filter((item)=>{
      if(item.export) {
        return true;
      }
    });
    if(flt.length === this.category_fields.data.length) {
      return true;
    }
    return false;
  }
  fetchCategoryFields() {
    storeGet(`/sysapi/category/${this.data.category}/fields`, this.category_fields);
  }
  exportData() {
    runInAction(()=> {
      this.submitting = true;
    });
    axios.post(`/sysapi/category/${this.data.category}/extendedExport`, {
      options: toJS(this.export_options),
      fields: toJS(this.export_fields),
      filter: this.data.filter,
      order: this.data.order,
    }).then((data)=> {
      runInAction(() => {
        this.submitting = false;
      });
      this.submit_result = data.data;
      if (data.data.answer) {
        window.location = data.data.answer.download_url;
        this.closeExport();
      }
    });
  }
  closeExport() {
    this.mapper = {};
    if(typeof window.exportListener !== "undefined") {
      window.exportListener.push({"cmd":"close_import"});
    }
  }
}

export default exportStore;